import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

export class OrganizerDetails extends Component {
    render() {
        let organizer = this.props.organizer;
        return (
            <Container className="p-5 bg-white">
                <Row>
                    <Col className="text-center">
                        <h2 className="mt-5 title-bd">{organizer.organizer}</h2>
                        <p className="body-lt text-color-theme-4">Organizer of the Program</p>
                    </Col>
                </Row>
            </Container>
        );
    }
}